/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorrespondingCredRequest
 */
export interface CorrespondingCredRequest {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof CorrespondingCredRequest
     */
    said: string;
    /**
     * Prone number in E164 format
     * @type {string}
     * @memberof CorrespondingCredRequest
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the CorrespondingCredRequest interface.
 */
export function instanceOfCorrespondingCredRequest(value: object): boolean {
    if (!('said' in value)) return false;
    return true;
}

export function CorrespondingCredRequestFromJSON(json: any): CorrespondingCredRequest {
    return CorrespondingCredRequestFromJSONTyped(json, false);
}

export function CorrespondingCredRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrespondingCredRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}

export function CorrespondingCredRequestToJSON(value?: CorrespondingCredRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'phoneNumber': value['phoneNumber'],
    };
}

